import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { stringify } from 'qs';
import {
  Select,
} from 'antd';
import { getDocumentStatuses } from '../../../actions/userProfile';

const stringifyOptions = {
  format: 'RFC1738',
  addQueryPrefix: true,
  sort: (a, b) => (a.localeCompare(b)),
};

class StatusSearchSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStatus: props.paramTools.params.statuses,
      documentStatuses: [],
    };
  }

  componentDidMount = async () => {
    await this.props.getDocumentStatuses();
    this.setState({ documentStatuses: this.props.allDocumentStatuses.document_statuses });
  }

  updateQuery = async (status) => {
    this.setState({ selectedStatus: status });
    const { paramTools, inboxActions, queryType } = this.props;
    const { params } = paramTools;
    const { getRecords } = inboxActions;
    if (params[queryType] === '') {
      delete params[queryType];
      params.page = 1;
    } else {
      params[queryType] = status;
      params.page = 1;
    }
    const query = stringify(params, stringifyOptions);
    await getRecords(query);
  }

  render() {
    const { documentStatuses, selectedStatus } = this.state;

    const selectedName = documentStatuses.find(o => o.id === parseInt(selectedStatus, 10))?.name;
    return (
      <div>
        <Select
          showSearch
          style={{ width: '220px', marginTop: 20 }}
          label="Document Status"
          placeholder="Search by Status"
          allowClear
          value={selectedName}
          onChange={option => this.updateQuery(option)}
          options={documentStatuses.map(docStatus => ({
            label: docStatus.name,
            value: docStatus.id,
          }))}
          filterOption={(input, option) =>
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        />
      </div>
    );
  }
}

StatusSearchSettings.propTypes = {
  inboxActions: PropTypes.object.isRequired,
  paramTools: PropTypes.object.isRequired,
  queryType: PropTypes.string,
  allDocumentStatuses: PropTypes.object.isRequired,
  getDocumentStatuses: PropTypes.func.isRequired,
};

StatusSearchSettings.defaultProps = {
  queryType: 'status',
};

export default connect(state => ({
  allDocumentStatuses: state.userProfile.allDocumentStatuses,
}), {
  getDocumentStatuses,
})(StatusSearchSettings);
